import TeachingPeriod from './TeachingPeriod';
export default TeachingPeriod;
